import HTTPError from "../error.js";
import { encodeAuthorizationHeader } from "../auth.js";
import { getPaymentRequestFromHeaders } from "../helpers/cachu.js";
import { fetchWithTimeout } from "../helpers/fetch.js";
/** Deletes a blob to a server */
export async function deleteBlob(server, hash, opts) {
    const url = new URL("/" + hash, server);
    const headers = {};
    // attach the auth if its already set
    if (opts?.auth)
        headers["Authorization"] = encodeAuthorizationHeader(opts.auth);
    let res = await fetchWithTimeout(url, {
        method: "DELETE",
        headers,
        signal: opts?.signal,
        timeout: opts?.timeout,
    });
    // handle auth and payment
    switch (res.status) {
        case 401: {
            const auth = opts?.auth || (await opts?.onAuth?.(server, hash));
            if (!auth)
                throw new Error("Missing auth handler");
            // Try delete with auth
            res = await fetchWithTimeout(url, {
                signal: opts?.signal,
                method: "DELETE",
                headers: { ...headers, Authorization: encodeAuthorizationHeader(auth) },
                timeout: opts?.timeout,
            });
            break;
        }
        case 402: {
            if (!opts?.onPayment)
                throw new Error("Missing payment handler");
            const { getEncodedToken } = await import("@cashu/cashu-ts");
            const request = getPaymentRequestFromHeaders(res.headers);
            const token = await opts.onPayment(server, hash, request);
            const payment = getEncodedToken(token);
            // Try delete with payment
            res = await fetchWithTimeout(url, {
                signal: opts?.signal,
                method: "DELETE",
                headers: { ...headers, "X-Cashu": payment },
                timeout: opts?.timeout,
            });
            break;
        }
    }
    // handle errors
    await HTTPError.handleErrorResponse(res);
    // return blob descriptor
    return res.ok;
}
